// Fil: src/SettingsModal.js

import React, { useState } from 'react';
import Modal from 'react-modal';

function SettingsModal({ isOpen, onRequestClose }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccessMessage('');

    if (newPassword !== confirmPassword) {
      setError('Nyt kodeord og bekræftelse matcher ikke.');
      return;
    }
    if (newPassword.length < 8) {
        setError('Nyt kodeord skal være mindst 8 tegn langt.');
        return;
    }

    setIsLoading(true);

    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/change-password`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ currentPassword, newPassword }),
            credentials: 'include'
        });

      const responseText = await response.text(); // Læs altid svar-body

      if (!response.ok) {
        throw new Error(responseText || 'Der opstod en fejl.');
      }

      setSuccessMessage(responseText); // Vis succesbesked fra serveren
      // Nulstil felter efter succes
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Nulstil alt, når modalen lukkes
  const handleClose = () => {
    setError('');
    setSuccessMessage('');
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    onRequestClose(); // Kald funktionen fra App.js
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel="Brugerindstillinger"
      className="ReactModal__Content" // Genbrug styling
      overlayClassName="ReactModal__Overlay" // Genbrug styling
    >
      <form onSubmit={handleSubmit} className="modal-form">
        <h3>Skift Kodeord</h3>
        
        {error && <p className="error-message">{error}</p>}
        {successMessage && <p className="success-message-inline">{successMessage}</p>}
        
        <div className="form-field">
          <label htmlFor="currentPassword">Nuværende Kodeord:</label>
          <input
            type="password"
            id="currentPassword"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
        </div>
        <div className="form-field">
          <label htmlFor="newPassword">Nyt Kodeord:</label>
          <input
            type="password"
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>
        <div className="form-field">
          <label htmlFor="confirmPassword">Bekræft Nyt Kodeord:</label>
          <input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        
        <div className="modal-actions">
          <button type="submit" disabled={isLoading}>
            {isLoading ? 'Opdaterer...' : 'Opdater Kodeord'}
          </button>
          <button type="button" onClick={handleClose} className="cancel-button">
            Luk
          </button>
        </div>
      </form>
    </Modal>
  );
}

export default SettingsModal;